// send message to app webview that animation has started
/** biome-ignore-all lint/suspicious/noAlert: allow alert */
export const webviewAnimStart = () => {
  // ios
  try {
    window.webkit?.messageHandlers?.animationStarted?.postMessage(true);
  } catch (e) {
    evite.error(e);
    alert(`An error occurred in fabricCreateIsPremium(ios): ${e}`);
  }

  // android
  try {
    if (window.webview?.animationStarted) window.webview.animationStarted(true);
  } catch (e) {
    evite.error(e);
    alert(`An error occurred in fabricCreateIsPremium(android): ${e}`);
  }
};

// send message to app webview that animation has finished
export const webviewAnimFinish = () => {
  // ios
  try {
    window.webkit?.messageHandlers?.animationFinished?.postMessage(true);
  } catch (e) {
    evite.error(e);
    alert(`An error occurred in fabricCreateIsPremium(ios): ${e}`);
  }

  // android
  try {
    if (window.webview?.animationFinished) window.webview.animationFinished(true);
  } catch (e) {
    evite.error(e);
    alert(`An error occurred in fabricCreateIsPremium(android): ${e}`);
  }
};

// send message to app webview that animation has been replayed
export const webviewAnimReplay = () => {
  // ios
  try {
    window.webkit?.messageHandlers?.animationReplay?.postMessage(true);
  } catch (e) {
    evite.error(e);
    alert(`An error occurred in fabricCreateIsPremium(ios): ${e}`);
  }

  // android
  try {
    if (window.webview?.animationReplay) window.webview.animationReplay(true);
  } catch (e) {
    evite.error(e);
    alert(`An error occurred in fabricCreateIsPremium(android): ${e}`);
  }
};
